<template>
    <input v-model="model" :id="id" :name="id" :type="attributes.type != undefined ? attributes.type : 'text'" :step="attributes.step != undefined ? attributes.step : ''" :min="attributes.min != undefined ? attributes.min : ''" :max="attributes.max != undefined ? attributes.max : ''" :maxlength="attributes.maxLength != undefined ? attributes.maxLength : ''" :placeholder="attributes.placeholder != undefined ? attributes.placeholder : ''" :class="attributes.classes != undefined ? attributes.classes : ''" :disabled="(disabled || (alwaysLocked != null && alwaysLocked)) && (attributes.type == undefined || attributes.type != 'hidden')" @input="onChange" @keydown.enter.prevent=''>
</template>

<script>
    export default {
        props: ['id', 'attributes', 'value', 'reset', 'locked'],

        data() {
            return {
                model: '',
                disabled: false,
                alwaysLocked: null
            }
        },

        created() {
            if(this.value != undefined)
                this.model = this.value;
            else if(this.attributes != undefined)
                this.model = this.attributes.value;

            if(this.attributes.alwaysLocked != undefined) {
                this.alwaysLocked = this.attributes.alwaysLocked;
            }

            if(this.locked != undefined && this.locked)
                this.disabled = this.locked;
            else if(this.attributes.disabled != undefined && this.attributes.disabled)
                this.disabled = this.attributes.disabled;

            if(this.model)
                this.broadcast();
        },

        watch: {
            reset() {
                if(this.reset == undefined || this.reset == null)
                    return;
                    
                if(this.value != undefined)
                    this.$set(this, 'model', this.value);
                else if(this.attributes.value != undefined)
                    this.$set(this, 'model', this.attributes.value);
                else
                    this.$set(this, 'model', '');

                this.broadcast(true);
            },

            locked() {
                this.disabled = this.locked;
            }
        },

        methods: {
            onChange() {
                this.broadcast();
            },

            broadcast(refresh) {
                this.$emit('changed', {id: this.id, value: this.model, refresh: refresh});
            }
        }
    }
</script>